import { call, put, takeEvery } from "redux-saga/effects";
import {
  GET_CANDIDATE_ASSESSMENT_OVERRIDE,
  GET_CANDIDATE_ASSESSMENT_STATUS,
} from "./actionTypes";

import {
  getCandidateAssessmentStatusError,
  getCandidateAssessmentStatusSuccess,
  overRideCandidateAssessmentError,
  overRideCandidateAssessmentSuccess,
} from "./actions";

import { getCall } from "../../../helpers/fakebackend_helper";

//restapi end point
import * as constClass from "../../../common/constant/constantURL";

function* assessmentDetailsHandler({ payload: { data } }) {
  try {
    const url =
      constClass.REST_API_CANDIDATE_ASSESSMENT_STATUS +
      `?candidateId=${data.candidateId}&jobId=${data.jobId}`;
    const response = yield call(getCall, url);
    yield put(getCandidateAssessmentStatusSuccess(response));
  } catch (error) {
    yield put(getCandidateAssessmentStatusError(error));
  }
}

function* assessmentOverRideHandler({ payload: { data } }) {
  try {
    let url =
      constClass.REST_API_CANDIDATE_ASSESSMENT_STATUS +
      `/override?candidateId=${data.candidateId}&jobId=${data.jobId}`;
     yield call(getCall, url);
    yield put(
      overRideCandidateAssessmentSuccess(
        "Assessment has been Overridden successfully."
      )
    );
  } catch (error) {
    yield put(overRideCandidateAssessmentError(error));
  }
}

function* ProcessAssessmentDetailsSaga() {
  yield takeEvery(GET_CANDIDATE_ASSESSMENT_STATUS, assessmentDetailsHandler);
  yield takeEvery(GET_CANDIDATE_ASSESSMENT_OVERRIDE, assessmentOverRideHandler);
}

export default ProcessAssessmentDetailsSaga;
